import type { $Fetch } from 'nitropack'

export const BillingRepository = (fetch: $Fetch) => ({
    downloadMandate: async (): Promise<Blob> => {
        return fetch<Blob>('/v2/billing/mandate', {
            method: 'GET',
            responseType: 'blob',
        })
    },
})
